var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 3.19531 2.67188 0.5 6 0.5C9.30469 0.5 12 3.19531 12 6.5C12 9.82812 9.30469 12.5 6 12.5C2.67188 12.5 0 9.82812 0 6.5ZM8.69531 5.46875C8.95312 5.21094 8.95312 4.8125 8.69531 4.55469C8.4375 4.29688 8.03906 4.29688 7.78125 4.55469L5.25 7.08594L4.19531 6.05469C3.9375 5.79688 3.53906 5.79688 3.28125 6.05469C3.02344 6.3125 3.02344 6.71094 3.28125 6.96875L4.78125 8.46875C5.03906 8.72656 5.4375 8.72656 5.69531 8.46875L8.69531 5.46875Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinIcon);
export default __webpack_public_path__ + "static/media/CheckinIcon.cba9bc2f01e4f90b301091991a82e475.svg";
export { ForwardRef as ReactComponent };